import { createAction, props } from '@ngrx/store';
import { Material, SelectedCostPerUnit } from '@shared/models';

export enum CostActions {
  // manufacturing/direct costs actions
  SubmitConcreteRate = '[Cost Page] Submit concrete rate',
  SubmitplacingRate = '[Cost Page] Submit cost to place',
  SubmitlabourCost = '[Cost Page] Submit rate to place',
  SubmitReinforcementRate = '[Cost Page] Submit reinforcement rate',
  SubmitfixingRate = '[Cost Page] Submit cost to fix',
  SubmitreinforcementLabourCost = '[Cost Page] Submit rate to fix',
  SubmitFormworkRate = '[Cost Page] Submit formwork rate',
  SubmitStructuralSteelRate = '[Cost Page] Submit structural steel rate',
  SubmitStructuralSteelRateConcrete = '[Cost Page] Submit steel rate - concrete',
  SubmitStructuralSteelMassConcrete = '[Cost Page] Submit structural steel mass',
  SubmitPercentageOfAreaRequiringPT = '[Cost Page] Submit percentage of area requiring PT',
  SubmitMndcRate = '[Cost Page] Submit MNDC rate',
  SubmitConcreteSupplyPlaceEF = '[Cost Page] Submit concrete supply place efficiency factor',
  SubmitReinforcementEF = '[Cost Page] Submit reinforcement efficicency factor',
  SubmitStructuralSteelEFConcrete = '[Cost Page] Submit structural steel efficiency factor concrete',
  SubmitPtEF = '[Cost Page] Submit pt efficiency factor',
  SubmitBallastRateConcrete = '[Cost Page] Submit ballast rate for concrete',
  SubmitBallastConcreteEF = '[Cost Page] Submit ballast concrete efficiency factor',
  SubmitStructuralSteelEF = '[Cost Page] Submit structural steel efficiency factor',
  SubmitFormworkEF = '[Cost Page] Submit formwork efficiency factor',
  ResetManufacturingCosts = '[Cost Page] Reset all data in the direct costs table',
  SubmitBallastRateSteel = '[Cost Page] Submit ballast rate for steel',
  SubmitBallastSteelEF = '[Cost Page] Submit ballast steel efficiency factor',
  // indirect costs actions - concrete
  SubmitFactorySetupAssumption = '[Cost Page] Submit factory setup assumption',
  SubmitLaunchUnitsAssumption = '[Cost Page] Submit launch units assumption',
  SubmitSiteMobilisationAssumption = '[Cost Page] Submit site mobilisation assumption',
  SubmitGeneralSiteCostsAssumption = '[Cost Page] Submit generral stie costs assumption',
  SubmitInsuranceAssumption = '[Cost Page] Submit insurance assumption',
  SubmitContractorRiskAssumption = '[Cost Page] Submit contractor risk assumption',
  SubmitWeatherRiskAssumption = '[Cost Page] Submit weather risk assumption',
  // indirect costs actions - steel
  SubmitManagementSupervisionAssumption = '[Cost Page] Submit management supervision assumption',
  SubmitPlantEquipmentLaunchAssumption = '[Cost Page] Submit plant equipment launch assumption',
  ResetIndirectCosts = '[Cost Page] Reset all data in the indirect costs table',
  // update selection options
  UpdateSelectedCostPerUnit = '[Cost Page] Update the selected cost per unit',
  UpdateSelectedMaterialCost = '[Cost Page] Update the selected material',
}


export const SubmitConcreteRate = createAction(
  CostActions.SubmitConcreteRate,
  props<{ concreteRate: number }>()
);

export const SubmitplacingRate = createAction(
  CostActions.SubmitplacingRate,
  props<{ placingRate: number }>()
);

export const SubmitlabourCost = createAction(
  CostActions.SubmitlabourCost,
  props<{ labourCost: number }>()
);

export const SubmitReinforcementRate = createAction(
  CostActions.SubmitReinforcementRate,
  props<{ reinforcementRate: number }>()
);

export const SubmitfixingRate = createAction(
  CostActions.SubmitfixingRate,
  props<{ fixingRate: number }>()
);

export const SubmitreinforcementLabourCost = createAction(
  CostActions.SubmitreinforcementLabourCost,
  props<{ reinforcementLabourCost: number }>()
);

export const SubmitFormworkRate = createAction(
  CostActions.SubmitFormworkRate,
  props<{ formworkRate: number }>()
);

export const SubmitStructuralSteelRate = createAction(
  CostActions.SubmitStructuralSteelRate,
  props<{ structuralSteelRate: number }>()
);

export const SubmitStructuralSteelRateConcrete = createAction(
  CostActions.SubmitStructuralSteelRateConcrete,
  props<{ structuralSteelRateConcrete: number }>()
);

export const SubmitStructuralSteelMassConcrete = createAction(
  CostActions.SubmitStructuralSteelMassConcrete,
  props<{ structuralSteelMassConcrete: number }>()
);

export const SubmitPercentageOfAreaRequiringPT = createAction(
  CostActions.SubmitPercentageOfAreaRequiringPT,
  props<{ percentageOfAreaRequiringPT: number }>()
);

export const SubmitBallastRateConcrete = createAction(
  CostActions.SubmitBallastRateConcrete,
  props<{ ballastRateConcrete: number }>()
);

export const SubmitBallastRateSteel = createAction(
  CostActions.SubmitBallastRateSteel,
  props<{ ballastRateSteel: number }>()
);

export const SubmitMndcRate = createAction(
  CostActions.SubmitMndcRate,
  props<{ mndcRate: number }>()
);

export const SubmitConcreteSupplyPlaceEF = createAction(
  CostActions.SubmitConcreteSupplyPlaceEF,
  props<{ concreteSupplyPlaceEF: number }>()
);

export const SubmitReinforcementEF = createAction(
  CostActions.SubmitReinforcementEF,
  props<{ reinforcementEF: number }>()
);

export const SubmitStructuralSteelEFConcrete = createAction(
  CostActions.SubmitStructuralSteelEFConcrete,
  props<{ structuralSteelEFConcrete: number }>()
);

export const SubmitPtEF = createAction(
  CostActions.SubmitPtEF,
  props<{ ptEF: number }>()
);

export const SubmitBallastConcreteEF = createAction(
  CostActions.SubmitBallastConcreteEF,
  props<{ ballastConcreteEF: number }>()
);

export const SubmitBallastSteelEF = createAction(
  CostActions.SubmitBallastSteelEF,
  props<{ ballastSteelEF: number }>()
);

export const SubmitStructuralSteelEF = createAction(
  CostActions.SubmitStructuralSteelEF,
  props<{ structuralSteelEF: number }>()
);

export const SubmitFormworkEF = createAction(
  CostActions.SubmitFormworkEF,
  props<{ formworkEF: number }>()
);

export const ResetManufacturingCosts = createAction(
  CostActions.ResetManufacturingCosts
);

// indirect cost assumptions - concrete

export const SubmitFactorySetupAssumption = createAction(
  CostActions.SubmitFactorySetupAssumption,
  props<{ factorySetupAssumption: number }>()
);

export const SubmitLaunchUnitsAssumption = createAction(
  CostActions.SubmitLaunchUnitsAssumption,
  props<{ launchUnitsAssumption: number }>()
);

export const SubmitSiteMobilisationAssumption = createAction(
  CostActions.SubmitSiteMobilisationAssumption,
  props<{ siteMobilisationAssumption: number }>()
);

export const SubmitGeneralSiteCostsAssumption = createAction(
  CostActions.SubmitGeneralSiteCostsAssumption,
  props<{ generalSiteCostsAssumption: number }>()
);

export const SubmitInsuranceAssumption = createAction(
  CostActions.SubmitInsuranceAssumption,
  props<{ insuranceAssumption: number }>()
);

export const SubmitContractorRiskAssumption = createAction(
  CostActions.SubmitContractorRiskAssumption,
  props<{ contractorRiskAssumption: number }>()
);

export const SubmitWeatherRiskAssumption = createAction(
  CostActions.SubmitWeatherRiskAssumption,
  props<{ weatherRiskAssumption: number }>()
);

// indirect cost assumptions - steel

export const SubmitManagementSupervisionAssumption = createAction(
  CostActions.SubmitManagementSupervisionAssumption,
  props<{ managementSupervisionAssumption: number }>()
);

export const SubmitPlantEquipmentLaunchAssumption = createAction(
  CostActions.SubmitPlantEquipmentLaunchAssumption,
  props<{ plantEquipmentLaunchAssumption: number }>()
);

export const ResetIndirectCosts = createAction(CostActions.ResetIndirectCosts);

// update the selected material from the cost page
export const UpdateSelectedMaterialCost = createAction(
  CostActions.UpdateSelectedMaterialCost,
  props<{ selectedMaterial: Material }>()
);

export const UpdateSelectedCostPerUnit = createAction(
  CostActions.UpdateSelectedCostPerUnit,
  props<{ selectedCostPerUnit: SelectedCostPerUnit }>()
);
